import React from "react";

const RELOAD_FLAG_KEY = "chunk-error-reload";

function isChunkLoadError(error) {
  const message = error?.message || "";
  return error?.name === "ChunkLoadError"
    || /Loading chunk [\w.-]+ failed/.test(message)
    || /Loading CSS chunk [\w.-]+ failed/.test(message)
    || /Failed to fetch dynamically imported module/.test(message);
}

export default class ChunkErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return;

    if (sessionStorage.getItem(RELOAD_FLAG_KEY)) return;

    sessionStorage.setItem(RELOAD_FLAG_KEY, "1");
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
